import "./UserProfileEdit.scss";
import { Form, Formik } from "formik";
import { ToastSuccess } from "../../Utils/Toast/ToastMsg";
import { passwordSchema } from "./PasswordSchema";
import { UserChangePassword } from "../../services/ChangeUserPassword";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Components/Header/Header";

const UserProfileEdit = () => {
  const [OldNewPass, setOldNewPass] = useState(false);
  const token = sessionStorage.getItem("userToken");
  const email = sessionStorage.getItem("email");
  const navigate = useNavigate();

  const submitAPI = async (values) => {
    console.log("submitAPI values", values);
    if (OldNewPass) {
      console.log("Old and new passwords are the same, exiting submitAPI");
      return;
    }
    const obj = {
      email: email,
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
    };
    console.log("API Request Object:", obj);
    try {
      const result = await UserChangePassword(obj, token);
      console.log("API Response:", result);
      if (result?.status === 200) {
        sessionStorage.setItem("userToken", result?.data?.auth_token);
        console.log("Navigating to /userLogin");
        sessionStorage.removeItem("userToken", result?.data?.auth_token);
        ToastSuccess(result?.message);
        navigate(`/userLogin`);
      }
    } catch (error) {
      console.error("Error during password change:", error);
    }
  };

  const validateOldNewPass = (oldPass, newPass) => {
    if (oldPass === "" && newPass === "") {
      setOldNewPass(false);
      return false;
    } else if (oldPass === newPass) {
      setOldNewPass(true);
      return true;
    } else {
      setOldNewPass(false);
      return false;
    }
  };

  return (
    <>
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="editProfileSectionUser">
              <Formik
                initialValues={{
                  oldPassword: "",
                  newPassword: "",
                  confirmPassword: "",
                }}
                enableReinitialize={true}
                validationSchema={passwordSchema}
                onSubmit={(values, { resetForm }) => {
                  console.log("Form Submitted with values:", values);
                  submitAPI(values, resetForm);
                }}
              >
                {({
                  errors,
                  touched,
                  handleChange,
                  values,
                  resetForm,
                }) => (
                  <Form>
                    <div className="editForm">
                      <div className="editProfileDiv">
                        <div className="fields">
                          <label>Old Password</label>
                          <br />
                          <input
                            id="oldPassword"
                            type="password"
                            name="oldPassword"
                            onChange={handleChange}
                            value={values.oldPassword}
                          />
                          {errors.oldPassword && touched.oldPassword ? (
                            <div className="errorMsgs">
                              {errors.oldPassword}
                            </div>
                          ) : null}
                        </div>
                        <div className="fields">
                          <label>New Password</label>
                          <br />
                          <input
                            id="newPassword"
                            type="password"
                            name="newPassword"
                            onChange={handleChange}
                            value={values.newPassword}
                          />
                          {validateOldNewPass(
                            values.oldPassword,
                            values.newPassword
                          ) ? (
                            <div className="errorMsgs">
                              Old Password or New password should not be same
                            </div>
                          ) : errors.newPassword && touched.newPassword ? (
                            <div className="errorMsgs">
                              {errors.newPassword}
                            </div>
                          ) : null}
                        </div>
                        <div className="fields">
                          <label>Confirm Password</label>
                          <br />
                          <input
                            id="confirmPassword"
                            type="password"
                            name="confirmPassword"
                            onChange={handleChange}
                            value={values.confirmPassword}
                          />
                          {errors.confirmPassword && touched.confirmPassword ? (
                            <div className="errorMsgs">
                              {errors.confirmPassword}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="editProfileBtn editProfieBtnSec">
                        <button className="editBtn" type="submit">
                          Submit
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfileEdit;
